var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsB2BIconAssignParking2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.54,
    height: 137.14,
    viewBox: "0 0 90.54 137.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.66,3V135.15h5V3Zm-83,2.5H89.16V.5H3.62Zm2.5,129.65V3h-5V135.15Zm80.54,0a2.5,2.5,0,0,0,5,0ZM89.16,3h2.5A2.5,2.5,0,0,0,89.16.5ZM3.62,3V.5A2.5,2.5,0,0,0,1.12,3ZM1.12,135.15a2.5,2.5,0,0,0,5,0Z",
    transform: "translate(-1.12 -0.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.89,42V96.77h5V42Zm0,54.75a2.5,2.5,0,0,0,5,0Zm5-54.75a2.5,2.5,0,1,0-5,0Z",
    transform: "translate(-1.12 -0.5)",
    fill: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.76,66.9H19v5H73.76ZM19,66.9a2.5,2.5,0,1,0,0,5Zm54.74,5a2.5,2.5,0,1,0,0-5Z",
    transform: "translate(-1.12 -0.5)",
    fill: "red"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsB2BIconAssignParking2);
export default __webpack_public_path__ + "static/media/ws-b2b-icon-assign-parking-2.cc1704bd19a6958db64a20b3c841b22f.svg";
export { ForwardRef as ReactComponent };